<template>

    <div>
        <div v-if="this.school_code === '008'">
            Dear Prospective Student,
            <br><br>
            Welcome to the University of the Southern Caribbean (USC) online application platform.
            <br> <br>
            <p>
                To complete the online application for an
                <a href="https://docs.google.com/document/d/1Nkrm73yAJEZWSjhtEdOLF0hLqO8kvmJa/edit?tab=t.0"
                   target="_blank">graduate programme</a> or
                <a href="https://drive.google.com/file/d/1dRbv_d1XwQWawLMTe2K1o-gQi-UeWkMv/view"
                   target="_blank">
                    undergraduate programme
                </a>,
                please ensure all
                <a href="https://drive.google.com/file/d/1uPSZZJLf1p5KJ86FkPZT1hYdYyr1wN9r/view"
                   target="_blank">graduate required documents</a>
                or
                <a href="https://docs.google.com/document/d/1tzDov_gS7v_SKTuk6n_nQ5gFMomkCOxX/edit?tab=t.0"
                   target="_blank">undergraduate required documents</a>
                are
                submitted. A green check mark next to each item will indicate that it was successfully
                uploaded. Additionally, you must review and agree to the terms outlined in the
                Declaration and Agreement section.
            </p>
            <p>
                You can monitor the progress of your application at any time through the
                application portal. We also recommend keeping your Application PIN readily
                available, as it will assist us in
                addressing any queries you may have more efficiently.


            </p>
            <p>
                If you have any questions or require assistance, feel free to contact us at
                <a href="mailto:apply@usc.edu.tt" target="_blank">apply@usc.edu.tt</a>.
            </p>
            <p>
                Regards,
            </p>
            <p>
                <b>Admissions and Enrolment Management</b><br>
                University of the Southern Caribbean
            </p>
        </div>
        <div v-else>
            Hello Prospective Student,
            <br>
            Welcome to {{ getSchoolInfo.schoolName }} ({{ getSchoolInfo.schoolShortName }}) online application platform. <br><br>
            In order to complete the online application for an undergraduate programme, you will need to submit the following  (a green check mark indicates that the document has been received):

            <ul>
                <li>Birth Certificate</li>
                <li>Passport-sized Photograph</li>

                <!--      <li>Financial Memorandum of Understanding (MOU)</li>-->
                <li>Proof of External Pass (or time table of the next exam sitting)</li>
                <li>Agree to the terms of the Declaration and Agreement section</li>
            </ul>
            <br>
            <p>
                You may effectively track your application progress and view the current status of your application in the application platform. Keep Application PIN near, it makes processing queries easier.

            </p>
            <p>
                If you have any questions you can always contact us at {{ getSchoolInfo.admissionEmail }}.


            </p>
            <p>
                Sincerely, <br><br>
                Recruitment and Admissions <br>
                {{ getSchoolInfo.schoolName }}
            </p>
        </div>
        <v-form @submit.prevent="goToNextPage">
            <v-row>
                <v-col class="d-flex justify-end mt-4">
                    <v-btn color="primary"
                     
                           type="submit"> Next</v-btn>
                </v-col>
            </v-row>
        </v-form>
        
    </div>
</template>

<script>
  import HelloWorld from '../components/HelloWorld'
  import {mapGetters, mapState} from "vuex";
  import { ref } from 'vue'
  import { RouterView, useRouter } from 'vue-router'

    
    
    export default {
        name: 'Home',
        data: () => ({
            school_code: process.env.VUE_APP_SCHOOL_CODE

        }),
        components: {
            HelloWorld,
        },

        computed: {
            ...mapState({
                getSchoolInfo: state => state.utilities.schoolInfo,
            })
        },
        methods:
        {

            goToNextPage() {
                const appProcesses = this.$store.state.user.appProcesses;

                // Home is the starting page, so select the first process
                const firstProcess = appProcesses.reduce((first, process) => {
                    return !first || process.stepOrder < first.stepOrder
                        ? process
                        : first;
                }, null);

                if (!firstProcess) {
                    console.error("No application processes found.");
                    return;
                }

                // Convert the process name into its route path
                const nextRoute =
                    "/" + firstProcess.processName.trim().replace(/\s+/g, "");

                this.$router.push(nextRoute);
            }
        },
    
            //this.$router.push('/ProgrammeSelection')
            //this.$router.go(1)

            //this.$store.dispatch('user/MoveToNextStep', { route: this.$route })
   
    
        
    mounted() {
      //console.log(typeof process.env.VUE_APP_SCHOOL_CODE);
    }
  }
</script>
